import { Fragment } from 'react';

export function UseOfApiServices() {
  return (
    <Fragment>
      Where a User accesses any content using our API, they are bound by our <a href="https://dev.cityfalcon.com/terms" target="_blank">API terms and conditions</a>. We cannot guarantee the accuracy, completeness, or veracity of any information transmitted through the API.
    </Fragment>
  );
}


export default UseOfApiServices;
